module.exports = __webpack_public_path__ + "static/media/banner-2.3467daa8.jpg";